import React from 'react';
import HelpTooltip from '../SteppedForm/HelpTooltip';

import {
  CheckOutlined as CheckOutlinedIcon,
  ClearOutlined as ClearOutlinedIcon
} from '@material-ui/icons';
import { Typography } from '@material-ui/core';
import { ButtonField, Step } from '../SteppedForm';

const StepTransferofvehicle = (props) => {
  return (
    <Step
      id="transferofvehicle"
      title="Transfer Of Vehicle"
      skip={(formdata) =>
        formdata.onboardcar === false ||
        formdata.tiger === true ||
        formdata.vehicles[props.state.vehicle_index].carbuy
      }
      nonext>
      <Typography variant="body1" class="formQuestion">
        Is this vehicle already operating within a 13cabs, 13limo, CHAMP or Silver Service fleet?
      </Typography>
      <HelpTooltip title="By selecting Yes you are telling us this vehicle is already a part of the fleet and a full installation is not required.">
        <ButtonField
          id="previously_fittedout"
          label="Yes"
          value={true}
          className="TopIconButton"
          startIcon={<CheckOutlinedIcon />}
        />
      </HelpTooltip>

      <HelpTooltip title="By selecting No you are telling us this vehicle requires a full installation to join the fleet.">
        <ButtonField
          id="previously_fittedout"
          label="No"
          value={false}
          className="TopIconButton"
          startIcon={<ClearOutlinedIcon />}
        />
      </HelpTooltip>
    </Step>
  );
};

export default StepTransferofvehicle;
